exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text_privacy p[data-v-b35b62ac] {\n\twidth: 100%;\n\theight: 100%;\n\ttext-indent: 4ch;\n}\n.text_privacy[data-v-b35b62ac] {\n\tpadding: 20px;\n}\n", ""]);

// exports
